<template>
  <div>
    <MazPhoneNumberInput
      class="phone-input"
      :class="[styleClasses, this.$attrs.class]"
      show-code-on-list
      no-example
      :autoFormat="false"
      :default-phone-number="phoneNumber"
      :default-country-code="country"
      :label="$t('auth.phone')"
      :required="isRequired"
      :disabled="disabled"
      :readonly="readonly"
      :only-countries="['GB', 'PL', 'US']"
      :translations="{
        countrySelector: {
          placeholder: 'Country code',
        },
        phoneInput: {
          placeholder: $t('auth.phone'),
        },
      }"
      @update="onUpdate"
      @update:model-value="onUpdateValue"
    />

    <ErrorMessage v-if="hasError" class="pl-[10px]">
      {{ $t(errorMsg) }}
    </ErrorMessage>

    <div class="pl-[10px]">
      <slot name="errors"></slot>
    </div>
  </div>
</template>

<script>
import MazPhoneNumberInput from "maz-ui/components/MazPhoneNumberInput";
import ErrorMessage from "@/components/Core/ErrorMessage.vue";

export default {
  components: { MazPhoneNumberInput, ErrorMessage },
  emits: ["update"],
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      default: "",
    },
    phoneNumber: {
      type: String,
      default: "",
    },
    country: {
      type: String,
      default: "GB",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: null,
    },
    anyDirty: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      result: null,
    };
  },
  computed: {
    hasError() {
      return this.anyDirty && this.errors && this.errors?.[this.name];
    },
    errorMsg() {
      return this.errors[this.name] instanceof Array
        ? this.errors[this.name][0]
        : this.errors[this.name];
    },
    styleClasses() {
      return {
        error: this.hasError,
        disabled: this.disabled,
      };
    },
  },
  methods: {
    onUpdateValue() {
      if (this.result?.nationalNumber != this.phoneNumber) {
        this.$emit("update", this.result);
      }
    },
    onUpdate($event) {
      this.result = $event;
    },
  },
};
</script>
